// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yx-widget/component/YxModal/Drawer/index.less
// module id = ./src/yx-widget/component/YxModal/Drawer/index.less
// module chunks = 43